/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum DocumentStatusEnum {
	All = "All",
	Active = "Active",
	Expired = "Expired",
}

export function DocumentStatusEnumFromJSON(json: any): DocumentStatusEnum {
	return DocumentStatusEnumFromJSONTyped(json, false);
}

export function DocumentStatusEnumFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): DocumentStatusEnum {
	return json as DocumentStatusEnum;
}

export function DocumentStatusEnumToJSON(
	value?: DocumentStatusEnum | null
): any {
	return value as any;
}
